import comboboxClasses from '../combobox/combobox.module.css'
import classes from './multi-select.module.css'

// Options reuse the Combobox class (see ui/select for why).
const MultiSelect = {
  classNames: {
    input: classes.input,
    option: comboboxClasses.option,
  },
}

export default MultiSelect
